import { CompositeScreenProps } from "@react-navigation/native"
import { observer } from "mobx-react-lite"
import { Checkbox, View } from "native-base"
import React, { FC, useEffect, useRef, useState } from "react"
import { Alert, Appearance, Platform, TextInput, ViewStyle } from "react-native"
import { AutoImage, Button, Input, Screen, Text } from "../../../../components"
import { TxKeyPath } from "../../../../i18n"
import { useStores } from "../../../../models"
import { LoginStack, resetRoot } from "../../../../navigators"
import { color } from "../../../../theme"

const ROOT: ViewStyle = {
  flexGrow: 1,
  paddingHorizontal: 16
}

const IMG_CONTAINER: ViewStyle = {
  marginTop: 28,
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 24
}

const BULLET_ITEM: ViewStyle = {
  flexDirection: "row",
  paddingVertical: 10
}

const DOT = (colorScheme:string): ViewStyle => ({
  width: 6,
  height: 6,
  borderRadius: 6,
  backgroundColor: colorScheme === 'light' ? color.palette.black : color.palette.white,
  marginTop: 8,
  marginRight: 8
})

const BTN_WRAPPER: ViewStyle = {
  marginTop: 38
}

const CONFIRM_WRAPPER: ViewStyle = {
  marginTop: 18
}

const INPUT: ViewStyle = {
  marginBottom: 18,
  marginTop: 12
}


export const DeleteAccountScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function DeleteAccountScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props
  const [ step, setStep ] = useState<number>(1);
  const [ disclaimer, setDisclaimer ] = useState<boolean>(false);
  const [ password, setPassword ] = useState<string>('');


  // Pull in one of our MST stores
  const { userStore, userStore: { user, loading: userLoading, error: userError } } = useStores()

  const TRASH = require("./trash.png");
  const isDisable = !(disclaimer && password !== '');
  const disabled = step === 1 ? disclaimer : isDisable;
  const userErrorRef = useRef(userError);
  const userRef = useRef(user);
  const inputRef = useRef<TextInput>();

  useEffect(() => {
    if (userRef.current !== user) resetRoot(LoginStack)
  }, [user])

  useEffect(() => {
    if (!userStore) return;
    if (userError && userErrorRef.current !== userError) {
      if (Platform.OS === 'web') {
        if (userError.response)
          confirm(userError.response.originalError.message)
        userStore.set('error', null)
      }
      else
        Alert.alert(
          userError.response.originalError.message,
          userError.response.data.message,
          [ { onPress: () => userStore.set('error', null) } ]
        );
    }
  }, [userError, userStore])

  const handleDelete = (order: number) => () => {
    if (order === 1) {
      setStep(2); setDisclaimer(false);
    } else userStore.deleteAccount(password);
  }

  const handleCheck = () => setDisclaimer(!disclaimer);
  const handleChange = text => setPassword(text)


  const Bullet = ({ text } : { text?: TxKeyPath }) => (
    <View style={BULLET_ITEM}>
      <View style={DOT(colorScheme)} />
      <Text preset="title4" tx={text} colorScheme={colorScheme} />
    </View>
  );

  const TermContent = () => (
    <View>
      <Text preset="title3" tx="deleteScreen.termDelete" colorScheme={colorScheme} />
      <Bullet text="deleteScreen.term1" />
      <Bullet text="deleteScreen.term2" />
      <Bullet text="deleteScreen.term3" />
    </View>
  )

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={color.primary}
      statusBar="light-content"
    >
      <View style={IMG_CONTAINER}>
        <AutoImage source={TRASH} resizeMode="contain" />
        {step === 1 ? <Text preset="display3" tx="deleteScreen.deletingAccount" mt="24px" colorScheme={colorScheme} /> : <Text preset="display3" tx="deleteScreen.deleteConfirm" mt="24px" colorScheme={colorScheme} /> }
      </View>
      {step === 1 ? <TermContent /> : (
      <View style={CONFIRM_WRAPPER}>
        <Text preset="title4" tx="deleteScreen.disclaimer" textAlign="center" colorScheme={colorScheme} />
        <Input ref={inputRef} value={password} onChangeText={handleChange} placeholderTx="deleteScreen.placeholder" type="password" style={INPUT} colorScheme={colorScheme} />
        {/* <CheckboxComp value={disclaimer} onToggle={handleCheck} tx="deleteScreen.agreement" labelPreset="body3" multiline colorScheme={colorScheme} /> */}
        <Checkbox
          value="one"
          onChange={handleCheck}
          colorScheme="blue"
          borderWidth={0.7}
          borderColor={color.primary}
        >
          <View alignItems="center">
            <Text tx="deleteScreen.agreement" preset="body3" colorScheme={colorScheme} marginLeft="16px" />
          </View>
        </Checkbox>
      </View>
      ) }
      <View style={BTN_WRAPPER}>
        <Button testID="jala:id/delete-button" tx="deleteScreen.delete" onPress={handleDelete(step)} disabled={disabled} loading={userLoading} colorScheme={colorScheme} />
      </View>
    </Screen>
  )
})
